import React from "react";
import { Box, List, ListItem, ListItemIcon, Stack } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../../wrapper/wrapper";
import { Steps, StepsInShort } from "./steps";
import {
  Bar,
  KeyPoint,
  Process,
  ProcessContainer,
  StepsText,
  Title,
} from "./working.components";
import DisplayImage from "../../../images/process/display-image.png";
import LayersIcon from "@mui/icons-material/Layers";

function HowItWorks() {
  return (
    <OuterWrapper sx={{ bgcolor: "#E5E6ED", py: "65px" }}>
      <InnerWrapper>
        <Title sx={{ px: { xs: 1.5 }, fontSize: { xs: 28, sm: "32px" } }}>
          How it Works
        </Title>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={{ xs: 5, md: 10 }}
          sx={{ px: { xs: 1.5 } }}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            sx={{ width: "100%" }}
          >
            {Steps.map((data) => {
              return (
                <ProcessContainer
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3.75}
                  sx={{
                    width: { xs: "92%", md: 450 },
                    pl: { xs: "30px", md: "50px" },
                  }}
                >
                  <Box
                    component="img"
                    src={data.icon}
                    alt=""
                    sx={{ width: 32 }}
                  />
                  <Box>
                    <Process step={"15px"}>{data.step}</Process>
                    <Process>{data.process}</Process>
                  </Box>
                </ProcessContainer>
              );
            })}
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={{ xs: 1, md: 2 }}
            sx={{ width: "100%" }}
          >
            <Box
              component={"img"}
              src={DisplayImage}
              alt=""
              sx={{ width: "100%", mb: 1 }}
            />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={4}
              sx={{ display: { xs: "none", md: "flex" } }}
            >
              <KeyPoint>8 weeks</KeyPoint>
              <Bar />
              <KeyPoint>Internship Certificate</KeyPoint>
              <Bar />
              <KeyPoint>Industry Level Project</KeyPoint>
            </Stack>

            <List sx={{ display: { xs: "initial", md: "none" } }}>
              {StepsInShort.map((item) => {
                return (
                  <ListItem sx={{ py: 0 }}>
                    <ListItemIcon>
                      <LayersIcon />
                    </ListItemIcon>
                    <StepsText primary={item} />
                  </ListItem>
                );
              })}
            </List>
          </Stack>
        </Stack>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default HowItWorks;
